const routes = {
  login: {
    root: "/login",
  },
  home: {
    root: "/home/manage-student",
  },
  studentDetails: "/home/manage-student/student-details",
  modifyOrder: "/home/manage-student/student-details/modify-order/:studentId",
  cancelOrder: "/home/manage-student/student-details/cancel-order/:studentId",
  default: "/",
  pageNotFound: "*",
};

export default routes;
